export const getUrlWithProtocol = (url: string) => {
  if (url.startsWith('https://')) return url
  if (url.startsWith('http://')) return `https://${url.slice(7)}`
  if (url.startsWith('//')) return `https:${url}`
  return url
}
